// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XXUtdmKC5uIE36CF {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 100px;
  min-height: calc(100vh - 100px);
  position: relative;
}

.rlz1VUU1NoUC6JS_ {
  margin-top: 108px;
  border-radius: 16px;
  max-width: 440px;
  padding: 36px;
  width: 100%;
}

.rlz1VUU1NoUC6JS_ .p-card-title {
  text-align: center;
  font-size: 30px;
  font-family: Roboto;
  color: #303030;
  font-weight: bold;
  margin-bottom: 8px;
}

.rlz1VUU1NoUC6JS_ .p-card-body {
  padding: 0;
}

.rlz1VUU1NoUC6JS_ .p-card-content {
  padding: 0;
}

.rlz1VUU1NoUC6JS_ .p-card-content > p {
  margin-bottom: 28px;
  text-align: center;
  color: #888;
  font-size: 14px;
}

/* ── Method circles ── */

.xOLYlsMN9RUIdvl4 {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 28px;
}

.Zz9e92nEU94eH8g4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
}

.W_Z5CGqKLQliyGp6 {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 2px solid #20336c;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background 0.18s,
    border-color 0.18s,
    color 0.18s;
  color: #20336c;
  font-size: 22px;
  padding: 0;
}

.W_Z5CGqKLQliyGp6:hover {
  background: #eef1f9;
}

.ua5wQ0jJp_UfFa1O {
  background: #20336c;
  color: #fff;
  border-color: #20336c;
}

.ua5wQ0jJp_UfFa1O:hover {
  background: #19295a;
}

.lXfo11huCI4iPdbb {
  border-color: #d9d9d9;
  color: inherit;
}

.lXfo11huCI4iPdbb:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

.d4T8q9SKFkkamnsn {
  font-size: 12px;
  color: #888;
  font-weight: 500;
}

/* ── Inline panel ── */

.jaswpN7lqLczEkHe {
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: xyInHs5x5dQf6tE2 0.2s ease;
}

@keyframes xyInHs5x5dQf6tE2 {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.X0NnJ5fYkpwKyjkL {
  font-size: 13px;
  color: #888;
  text-align: center;
}

.HxT8iIB6tGUyXryX {
  width: 100%;
  padding-inline: 18px;
  border-radius: 12px;
  height: 50px;
  font-size: 16px;
  border: 1.5px solid #d9d9d9;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.HxT8iIB6tGUyXryX:focus {
  border-color: #20336c;
  box-shadow: 0 0 0 3px rgba(32, 51, 108, 0.08);
}

._DDhAERvS0w8CRUO {
  width: 100%;
  height: 48px;
  border-radius: 12px;
  background-color: #20336c;
  border-color: #20336c;
  font-weight: 600;
  font-size: 15px;
}

._DDhAERvS0w8CRUO:hover {
  background-color: #19295a !important;
  border-color: #19295a !important;
}

._DDhAERvS0w8CRUO:focus {
  box-shadow: none;
}

.tlILPHW2YhDUHsE2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ZP6IEuz8whA1m9Ew {
  font-size: 13px;
  color: #aaa;
}

.XahmzaMSUEyP741M {
  font-size: 13px;
  color: #1976d2;
  text-decoration: underline;
}

.iu1bXt3RkjoGpdcr {
  font-size: 13px;
  color: #c62828;
  text-align: center;
}

.zz5h81i2W0wfOtlz {
  margin-top: 0.4rem;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/StudentLogin.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;;eAGa;EACb,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qCAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".wrapper {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  margin-top: 100px;\r\n  min-height: calc(100vh - 100px);\r\n  position: relative;\r\n}\r\n\r\n.card {\r\n  margin-top: 108px;\r\n  border-radius: 16px;\r\n  max-width: 440px;\r\n  padding: 36px;\r\n  width: 100%;\r\n}\r\n\r\n.card :global(.p-card-title) {\r\n  text-align: center;\r\n  font-size: 30px;\r\n  font-family: Roboto;\r\n  color: #303030;\r\n  font-weight: bold;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.card :global(.p-card-body) {\r\n  padding: 0;\r\n}\r\n\r\n.card :global(.p-card-content) {\r\n  padding: 0;\r\n}\r\n\r\n.card :global(.p-card-content > p) {\r\n  margin-bottom: 28px;\r\n  text-align: center;\r\n  color: #888;\r\n  font-size: 14px;\r\n}\r\n\r\n/* ── Method circles ── */\r\n\r\n.methodRow {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 20px;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.methodItem {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 7px;\r\n}\r\n\r\n.methodCircle {\r\n  width: 64px;\r\n  height: 64px;\r\n  border-radius: 50%;\r\n  border: 2px solid #20336c;\r\n  background: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition:\r\n    background 0.18s,\r\n    border-color 0.18s,\r\n    color 0.18s;\r\n  color: #20336c;\r\n  font-size: 22px;\r\n  padding: 0;\r\n}\r\n\r\n.methodCircle:hover {\r\n  background: #eef1f9;\r\n}\r\n\r\n.methodCircleActive {\r\n  background: #20336c;\r\n  color: #fff;\r\n  border-color: #20336c;\r\n}\r\n\r\n.methodCircleActive:hover {\r\n  background: #19295a;\r\n}\r\n\r\n.methodCircleGoogle {\r\n  border-color: #d9d9d9;\r\n  color: inherit;\r\n}\r\n\r\n.methodCircleGoogle:hover {\r\n  background: #f5f5f5;\r\n  border-color: #bbb;\r\n}\r\n\r\n.methodLabel {\r\n  font-size: 12px;\r\n  color: #888;\r\n  font-weight: 500;\r\n}\r\n\r\n/* ── Inline panel ── */\r\n\r\n.panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  animation: panelIn 0.2s ease;\r\n}\r\n\r\n@keyframes panelIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-6px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.panelHint {\r\n  font-size: 13px;\r\n  color: #888;\r\n  text-align: center;\r\n}\r\n\r\n.panelInput {\r\n  width: 100%;\r\n  padding-inline: 18px;\r\n  border-radius: 12px;\r\n  height: 50px;\r\n  font-size: 16px;\r\n  border: 1.5px solid #d9d9d9;\r\n  outline: none;\r\n  box-sizing: border-box;\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.panelInput:focus {\r\n  border-color: #20336c;\r\n  box-shadow: 0 0 0 3px rgba(32, 51, 108, 0.08);\r\n}\r\n\r\n.panelBtn {\r\n  width: 100%;\r\n  height: 48px;\r\n  border-radius: 12px;\r\n  background-color: #20336c;\r\n  border-color: #20336c;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n}\r\n\r\n.panelBtn:hover {\r\n  background-color: #19295a !important;\r\n  border-color: #19295a !important;\r\n}\r\n\r\n.panelBtn:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.resendRow {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.timerText {\r\n  font-size: 13px;\r\n  color: #aaa;\r\n}\r\n\r\n.resendLink {\r\n  font-size: 13px;\r\n  color: #1976d2;\r\n  text-decoration: underline;\r\n}\r\n\r\n.errorText {\r\n  font-size: 13px;\r\n  color: #c62828;\r\n  text-align: center;\r\n}\r\n\r\n.errorMessage {\r\n  margin-top: 0.4rem;\r\n  display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `XXUtdmKC5uIE36CF`;
export var card = `rlz1VUU1NoUC6JS_`;
export var methodRow = `xOLYlsMN9RUIdvl4`;
export var methodItem = `Zz9e92nEU94eH8g4`;
export var methodCircle = `W_Z5CGqKLQliyGp6`;
export var methodCircleActive = `ua5wQ0jJp_UfFa1O`;
export var methodCircleGoogle = `lXfo11huCI4iPdbb`;
export var methodLabel = `d4T8q9SKFkkamnsn`;
export var panel = `jaswpN7lqLczEkHe`;
export var panelIn = `xyInHs5x5dQf6tE2`;
export var panelHint = `X0NnJ5fYkpwKyjkL`;
export var panelInput = `HxT8iIB6tGUyXryX`;
export var panelBtn = `_DDhAERvS0w8CRUO`;
export var resendRow = `tlILPHW2YhDUHsE2`;
export var timerText = `ZP6IEuz8whA1m9Ew`;
export var resendLink = `XahmzaMSUEyP741M`;
export var errorText = `iu1bXt3RkjoGpdcr`;
export var errorMessage = `zz5h81i2W0wfOtlz`;
export default ___CSS_LOADER_EXPORT___;
